import script from "./BarSuppliesDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarSuppliesDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./BarSuppliesDrawer.vue?vue&type=style&index=0&id=4a479eb0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a479eb0"]])

export default __exports__